export const MANAGE_USER_API='/account/manage-user';

export const MANAGE_GROUP_API='/account/manage-group';

export const TRANSCRIPT_API='/account/generate-transcript';

export const READ_ALERTS_API='/account/read-alerts';

export const CONVERSATION_BOOKMARKS_API='/fetch-bookmarked-conversations';

export const ALERTS_BY_CONVERSATION_API='/fetch-alerts-by-conversation-id';